export default __webpack_public_path__ + "static/media/bathroom2-afterA-1920w.c0e0fa64.webp";